// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { AuthControllerTestAuthResponse, ProspectsControllerFindAllByParamsData, ProspectsControllerFindAllByParamsResponse, CreditsControllerGetUserCreditsResponse, OutreachControllerDebugDeleteProspectFromSequenceData, OutreachControllerDebugDeleteProspectFromSequenceResponse, LookupsControllerPerformLookupV2Data, LookupsControllerPerformLookupV2Response, LookupsControllerRevealPhoneData, LookupsControllerRevealPhoneResponse, StripeControllerHandleWehbhookResponse, WebhooksControllerHandleSupabaseWebhooksResponse, WebhooksControllerHandleFindymailWebhookData, WebhooksControllerHandleFindymailWebhookResponse, WebhooksControllerHandleApolloWebhookData, WebhooksControllerHandleApolloWebhookResponse, HealthControllerCheckResponse } from './types.gen';

export class DefaultService {
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static authControllerTestAuth(): CancelablePromise<AuthControllerTestAuthResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/test'
        });
    }
    
}

export class ProspectsService {
    /**
     * @param data The data for the request.
     * @param data.domain
     * @param data.seniorityLevel
     * @param data.country
     * @param data.department
     * @param data.start
     * @returns unknown
     * @throws ApiError
     */
    public static prospectsControllerFindAllByParams(data: ProspectsControllerFindAllByParamsData): CancelablePromise<ProspectsControllerFindAllByParamsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/prospects',
            query: {
                domain: data.domain,
                seniorityLevel: data.seniorityLevel,
                country: data.country,
                department: data.department,
                start: data.start
            }
        });
    }
    
}

export class CreditsService {
    /**
     * Displays available credit balance
     * @returns unknown
     * @throws ApiError
     */
    public static creditsControllerGetUserCredits(): CancelablePromise<CreditsControllerGetUserCreditsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/credits'
        });
    }
    
}

export class OutreachService {
    /**
     * [DEBUG] Deletes prospect from the sequence
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static outreachControllerDebugDeleteProspectFromSequence(data: OutreachControllerDebugDeleteProspectFromSequenceData): CancelablePromise<OutreachControllerDebugDeleteProspectFromSequenceResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/outreach',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class LookupsService {
    /**
     * Initiates lookup process
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static lookupsControllerPerformLookupV2(data: LookupsControllerPerformLookupV2Data): CancelablePromise<LookupsControllerPerformLookupV2Response> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v2/lookups',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Initiates phone number reveal process
     * @param data The data for the request.
     * @param data.lookupId ID of the lookup to reveal phone number for
     * @returns unknown
     * @throws ApiError
     */
    public static lookupsControllerRevealPhone(data: LookupsControllerRevealPhoneData): CancelablePromise<LookupsControllerRevealPhoneResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/lookups/{lookupId}/reveal-phone',
            path: {
                lookupId: data.lookupId
            }
        });
    }
    
}

export class PaymentsService {
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static stripeControllerHandleWehbhook(): CancelablePromise<StripeControllerHandleWehbhookResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stripe/webhooks'
        });
    }
    
}

export class WebhooksService {
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static webhooksControllerHandleSupabaseWebhooks(): CancelablePromise<WebhooksControllerHandleSupabaseWebhooksResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/webhooks/supabase'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.webhookId
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static webhooksControllerHandleFindymailWebhook(data: WebhooksControllerHandleFindymailWebhookData): CancelablePromise<WebhooksControllerHandleFindymailWebhookResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/webhooks/findymail/{id}',
            path: {
                id: data.id
            },
            query: {
                webhookId: data.webhookId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.webhookId
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static webhooksControllerHandleApolloWebhook(data: WebhooksControllerHandleApolloWebhookData): CancelablePromise<WebhooksControllerHandleApolloWebhookResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/webhooks/apollo/{id}',
            path: {
                id: data.id
            },
            query: {
                webhookId: data.webhookId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class HealthService {
    /**
     * @returns unknown The Health Check is successful
     * @throws ApiError
     */
    public static healthControllerCheck(): CancelablePromise<HealthControllerCheckResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/health',
            errors: {
                503: 'The Health Check is not successful'
            }
        });
    }
    
}